function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.content : '';
}

async function request(method, url, body) {
  const isForm = typeof FormData !== 'undefined' && body instanceof FormData;
  const headers = { Accept: 'application/json', 'X-CSRF-Token': csrfToken() };
  if (body && !isForm) headers['Content-Type'] = 'application/json';

  const res = await fetch(url, {
    method,
    credentials: 'same-origin',
    headers,
    body: body ? (isForm ? body : JSON.stringify(body)) : undefined,
  });
  if (res.status === 204) return null;

  let json = null;
  try {
    json = await res.json();
  } catch (_) {
    json = null;
  }
  if (!res.ok) {
    throw new Error((json && json.error) || `Request failed (${res.status})`);
  }
  return json;
}

function filesForm(field, files) {
  const form = new FormData();
  files.forEach((file) => form.append(field, file));
  return form;
}

export default function adminActivitiesApi(basePath) {
  const item = (id) => `${basePath}/${id}`;
  return {
    get: (id) => request('GET', item(id)),
    create: (attrs) => request('POST', basePath, attrs),
    update: (id, attrs) => request('PATCH', item(id), attrs),
    destroy: (id) => request('DELETE', item(id)),
    addPictures: (id, files) => request('POST', `${item(id)}/pictures`, filesForm('images[]', files)),
    updatePicture: (id, pictureId, attrs) => request('PATCH', `${item(id)}/pictures/${pictureId}`, attrs),
    deletePicture: (id, pictureId) => request('DELETE', `${item(id)}/pictures/${pictureId}`),
    uploadTeaser: (id, file) => request('POST', `${item(id)}/teaser`, filesForm('teaser_gif', [file])),
    teaserFromPicture: (id, pictureId) => request('POST', `${item(id)}/teaser/from_picture/${pictureId}`),
    deleteTeaser: (id) => request('DELETE', `${item(id)}/teaser`),
  };
}
